import {Component, OnInit} from '@angular/core';
import {Company} from 'classes/company';
import FileSaver from 'file-saver';
import {TargetGroup, TARGETGROUP_DUMMIES} from 'shared/models/target-groups/target-group';

import {ExportService} from './services/export.service';
import { Content } from 'shared/models/contents/content';

@Component({
  selector: 'export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css'],
})

export class ExportComponent {
  private startDateISO: string;
  private endDateISO: string;
  public statisticsType: string;

  public selectedCompany: Company;
  public selectedTargetGroup: TargetGroup;
  public selectedContent: Content;

  public selectedCompanies: Array<Company> = [];
  public selectedTargetGroups: Array<TargetGroup> = [];
  public selectedContents: Array<Content> = [];

  public companies: Array<Company> = [];
  public targetGroups: Array<TargetGroup> = [];
  public contents: Array<Content> = [];

  public allContentsSelected: boolean = false;

  constructor(private exportService: ExportService) { }

  public ngOnInit(): void {
    this.exportService.getAllCompanies()
      .subscribe((companies: Array<Company>) => {
        this.companies = companies;
      });

    this.exportService.getAllTargetGroups()
      .subscribe((targetGroups: Array<TargetGroup>) => {
        this.targetGroups = targetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
      });

    this.exportService.getAllContents()
      .subscribe((contents: Array<Content>) => {
        this.contents = contents;
      });
  }

  public handleStartDateChange(date: Date): void {
    this.startDateISO = date.toISOString().split('T')[0];
  }

  public handleEndDateChange(date: Date): void {
    this.endDateISO = date.toISOString().split('T')[0];
  }

  public startExport(): void {
    const companyIds: Array<string> = this.selectedCompanies.map((company: Company) => {
      return company._id;
    });

    const targetGroupIds: Array<string> = this.selectedTargetGroups.map((targetGroup: TargetGroup) => {
      return targetGroup._id;
    });

    const contentIds: Array<string> = this.selectedContents.map((content: Content) => {
      return content._id;
    });

    if (this.statisticsType === 'Daily') {
      this.exportService.getDailyExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds)
        .subscribe((response: Blob) => {
          FileSaver.saveAs(response, `Daily_${this.startDateISO}_${this.endDateISO}.csv`);
        });
    } else if (this.statisticsType === 'Fragen') {
      this.exportService.getQuestionsExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds)
        .subscribe((response: Blob) => {
          FileSaver.saveAs(response, `Questions_${this.startDateISO}_${this.endDateISO}.csv`);
        });
    } else if (this.statisticsType === 'Dialogs') {
      this.exportService.getDialogsExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds)
        .subscribe((response: Blob) => {
          FileSaver.saveAs(response, `Dialogs_${this.startDateISO}_${this.endDateISO}.csv`);
        });
    } else if (this.statisticsType === 'Tipps') {
      this.exportService.getTiplistsExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds)
        .subscribe((response: Blob) => {
          FileSaver.saveAs(response, `Tipps_${this.startDateISO}_${this.endDateISO}.csv`);
        });
    } else if (this.statisticsType === 'Themenpakete') {
        this.exportService.getContentsExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds, contentIds)
          .subscribe((response: Blob) => {
            FileSaver.saveAs(response, `Themenpakete_${this.startDateISO}_${this.endDateISO}.csv`);
          });
    } else if (this.statisticsType === 'Episoden') {
      this.exportService.getEpisodesExport(this.startDateISO, this.endDateISO, companyIds, targetGroupIds)
        .subscribe((response: Blob) => {
          FileSaver.saveAs(response, `Episoden.csv`);
        });
    }
  }

  public isDisabled(): boolean {
    if ( (this.endDateISO && this.startDateISO && this.statisticsType && 
        (this.statisticsType !== 'Themenpakete' || this.selectedContents.length > 0)) 
      || this.statisticsType == 'Episoden' ) {
      return false;
    }
    return true;
  }

  public selectCompany(company: Company | string): void {
    if (this.isCompany(company)) {
      this.selectedCompanies.push(company);
      this.companies.splice(this.companies.indexOf(company), 1);
    }
  }

  public deselectCompany(company: Company): void {
    this.companies.push(company);
    this.selectedCompanies.splice(this.selectedCompanies.indexOf(company), 1);
  }

  private isCompany(obj: any): obj is Company {
    return obj._id !== undefined
  }

  public selectTargetGroup(targetGroup: TargetGroup | string): void {
    if (this.isTargetGroup(targetGroup)) {
      this.selectedTargetGroups.push(targetGroup);
      this.targetGroups.splice(this.targetGroups.indexOf(targetGroup), 1);
    }
  }

  public deselectTargetGroup(targetGroup: TargetGroup): void {
    this.targetGroups.push(targetGroup);
    this.selectedTargetGroups.splice(this.selectedTargetGroups.indexOf(targetGroup), 1);
  }

  private isTargetGroup(obj: any): obj is TargetGroup {
    return obj._id !== undefined
  }

  public selectContent(content: Content | string): void {
    if (this.isContent(content)) {
      this.selectedContents.push(content);
      this.contents.splice(this.contents.indexOf(content), 1);
    }
  }

  public deselectContent(content: Content): void {
    this.contents.push(content);
    this.selectedContents.splice(this.selectedContents.indexOf(content), 1);
  }

  private isContent(obj: any): obj is Content {
    return obj._id !== undefined
  }

  public toggleAllContents(): void {
    if (this.allContentsSelected) {
      // Alle Themenpakete auswählen
      this.selectedContents = [...this.selectedContents, ...this.contents];
      this.contents = [];
    } else {
      // Alle Themenpakete abwählen
      this.contents = [...this.contents, ...this.selectedContents];
      this.selectedContents = [];
    }
  }

}


// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/export.component.ts